import ValidateModule from "./ValidateModule";

import type { IEventChannel, ApiOpts } from "../model/Models";
import type AjaxRequestBroker from "../AjaxRequestBroker";
import type CacheModule from "./CacheModule";

const $: JQueryStatic = global.$;
const es = global.es;

/**
 * @class UploadModule
 * Object providing Upload
 */
export default class UploadModule {
    private eventChannel: IEventChannel;
    private rqBroker: AjaxRequestBroker;
    private resourceName: string;
    private cache: CacheModule;

    /**
     * 
     * @param eventChannel 
     * @param rqBroker 
     * @param resourceName 
     * @param cache 
     */
    constructor(eventChannel: IEventChannel, rqBroker: AjaxRequestBroker, resourceName: string, cache: CacheModule) {
        this.eventChannel = eventChannel;
        this.rqBroker = rqBroker;
        this.resourceName = resourceName;
        this.cache = cache;

        // TODO FIXME Does this even make sense nowadays?
        eventChannel.addListener("onDestroy", () => {
            // prevent memory leaks when the map widget is destroyed
            this.eventChannel = this.rqBroker = this.resourceName = this.cache = null;
        });

        this.parse = this.parse.bind(this);
        this.deleteFile = this.deleteFile.bind(this);
    }

    /**
     * Starts the parsing process of an uploaded file
     * 
     * @param filename 
     * @param model 
     * @param params additional parameters required by other imports than CSV
     * @param opts 
     * 
     * @returns a jquery deferred object resolved when the file is parsed
     */
    parse(filename: string, model: object, params: object, opts?: ApiOpts) {
        if (!ValidateModule.checkMandatoryArg(model)) {
            return es.util.deferred.rejected();
        }

        var importParams = {
            'key': filename,
            'meta': model
        };

        importParams = $.extend(importParams, params);

        this.cache?.clear('AsyncTasks');

        if (!filename) {
            importParams.importType = "SALESFORCE";
            es.log.info("importParams", importParams);

            return es.api.integrationSalesforce.doSalesforceImport(importParams, null, false);
        }

        const url = es.url + 'web/config/upload/ImportFile';

        return this.rqBroker.doPost({
            url: url,
            opts: opts,
            data: importParams
        });
    }

    /**
     * Deletes an uploaded file from the server
     *
     * @param filename filename to be deleted
     * @param opts 
     *
     * @return a jquery deferred promise object
     */
    deleteFile(filename: string, opts?: ApiOpts) {
        if (!ValidateModule.checkMandatoryArg(filename)) {
            return es.util.deferred.rejected();
        }

        const data = es.util.url.fromParams({'filename': filename});
        const url = es.url + 'web/config/upload/DeleteFile?' + data;

        // TODO: should reject deferred if file is not deleted?!
        return this.rqBroker.doPost({
            url: url,
            opts: opts
        }).done((rs) => {
            if (rs.file_deleted) { // TODO: should fire if file is not deleted?!
                // TODO !!! config.getEventChannel().fireEvent('onDeleteFile', rs);
            }
        });
    }
}
